module.exports = __webpack_public_path__ + "static/media/photography.ee056420.svg";